import { PluginSetup } from '@leverege/expression-editor';
import Actions from './actions/PluginSetup.js';
import Attributes from './attributes/PluginSetup.js';
import Components from './components/PluginSetup.js';
import Models from './models/PluginSetup.js';
import ModelEditors from './modelEditors/PluginSetup.js';
import Analyzers from './analyzer/PluginSetup.js';
import FilterSetup from './filter/PluginSetup.js';
import LayersSetup from './layers/PluginSetup.js';
import DataViewerSetup from './dataViewers/PluginSetup.js';
function install(molten) {
  Actions.install(molten);
  Attributes.install(molten);
  Components.install(molten);
  ModelEditors.install(molten);
  Models.install(molten);
  Analyzers.install(molten);
  PluginSetup.install(molten);
  FilterSetup.install(molten);
  LayersSetup.install(molten);
  DataViewerSetup.install(molten);
}
export { install };
export default {
  install
};